var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterOne3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38406 16.4519C3.20613 16.448 3.03427 16.3864 2.89427 16.2765C2.75427 16.1667 2.65369 16.0143 2.60763 15.8424L1.64961 12.267C1.60354 12.0951 1.61448 11.9129 1.68078 11.7477C1.74707 11.5826 1.86515 11.4434 2.01729 11.351L18.0599 1.30428C18.169 1.23802 18.2921 1.19808 18.4194 1.18763C18.5467 1.17717 18.6746 1.1965 18.7931 1.24406C18.9116 1.29163 19.0174 1.36614 19.1022 1.46168C19.1869 1.55722 19.2482 1.67118 19.2813 1.79453L23.1133 16.096C23.1464 16.2194 23.1503 16.3487 23.1247 16.4738C23.0991 16.5989 23.0447 16.7164 22.9658 16.8168C22.887 16.9173 22.7858 16.998 22.6704 17.0526C22.5549 17.1071 22.4284 17.1341 22.3007 17.1313L3.38406 16.4519Z",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06411 16.5835L8.01734 20.141C8.0738 20.3518 8.21166 20.5314 8.40059 20.6405C8.58952 20.7496 8.81404 20.7791 9.02476 20.7227L12.2029 19.8711C12.4136 19.8146 12.5933 19.6768 12.7023 19.4878C12.8114 19.2989 12.841 19.0744 12.7845 18.8637L9.51367 6.65674",
    stroke: "#3B4443",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterOne3);
export default __webpack_public_path__ + "static/media/footer-one-3.6550a8081a6d7f21c84d7fb1307eb356.svg";
export { ForwardRef as ReactComponent };